import React from "react";
import { withTranslation } from "react-i18next";
import VerticalDialog from "src/components/VerticalDialog";
import getImageSrc from "src/utils/getImageSrc";

function StopLullabyPlayerDialog({ t, isOpen, onDismiss }) {
  return (
    <VerticalDialog
      isOpen={isOpen}
      heading={t("lullaby.stopLullabyPlayerDialog.heading")}
      text={t("lullaby.stopLullabyPlayerDialog.text")}
      imageSrc={getImageSrc("stop-lullaby.svg")}
      buttonTop={{
        text: t("buttons.keepPlaying"),
        onClick: () =>
          onDismiss({
            shouldStopPlaying: false
          })
      }}
      buttonBottom={{
        text: t("buttons.stop"),
        onClick: () =>
          onDismiss({
            shouldStopPlaying: true
          })
      }}
    />
  );
}

export default withTranslation()(StopLullabyPlayerDialog);
